(function(ns) {
	"use strict";

	var util = ns.util;

	var rules = {
		name: ["notEmpty", "maxLength:200"],
		kana: ["notEmpty", "kana", "maxLength:200"],
		representative_name: ["notEmpty", "maxLength:200"],
		postal_code: ["notEmpty", "postalJP"],
		prefecture: ["notEmpty", "maxLength:4"],
		city: ["notEmpty", "maxLength:200"],
		address: ["notEmpty", "maxLength:200"],
		address2: ["maxLength:200"],
		tel: ["notEmpty", "phoneJPFormat", "phoneJPLength"],
		fax: ["phoneJPFormat", "phoneJPLength"],
		website: ["url", "maxLength:250"],
		public_email: ["email"],
		personnel_name: ["notEmpty", "maxLength:200"],
		personnel_kana: ["notEmpty", "kana", "maxLength:200"],
		personnel_belongs_to: ["maxLength:100"],
		personnel_tel: ["notEmpty", "phoneJPFormat", "phoneJPLength"],
		personnel_fax: ["phoneJPFormat", "phoneJPLength"],
		login_email: ["notEmpty", "email"],
		send_doc_to: ["radio_checked"],
		send_doc_to_address: ["maxLength:1000"],
	};

	util.component("company-view", {
		data: function() {
			return {
				state: ns.store.state,
				entry: ns.store.entry,
				entry_error: ns.store.entry_error
			};
		},
		methods: {
			complete: function() {
				var me = this,
				errorCount = util.validate(me.entry, rules, me.entry_error);

				if (me.entry.send_doc_to !== "その他") {
					// me.entry.send_doc_to_address = null;
				} else {
					if (!ns.validator.notEmpty(me.entry.send_doc_to_address)) {
						errorCount++;
						me.entry_error.send_doc_to_address = "send_doc_to_address";
					}
				}

				if (errorCount === 0) {
					me.$emit("viewdidcomplete", "company");
				} else {
					console.warn("エラーがあります");
					// 描画更新後に実行
					setTimeout(function() {
						var invalidInput = me.$el.querySelector(".is-invalid");
						if (!invalidInput) return;
						BS.Scroll.toElement(invalidInput.parentNode, 60);
					});
				}
			},
			fillPostalCode: function(event) {
				var me = this,
				entry = me.entry,
				postalCode = ns.validator.postalJP(entry.postal_code);
				if (!postalCode || !YubinBango) {
					return;
				}
				new YubinBango.Core(postalCode, function(result) {
					if (!result.region) {
						// console.log(result);
						return;
					}
					entry.prefecture = result.region;
					entry.city = result.locality;
					entry.address = result.street + result.extended;
					me.$forceUpdate();

					var addressE = event.target.closest(".h-adr");
					if (!addressE) return;
					var streetE = addressE.querySelector(".p-street");
					if (!streetE) return;
					streetE.focus();
				});
			},
			copyCompanyToPersonnel: function() {
				var entry = this.entry;
				var fields = {
					tel: "personnel_tel",
					fax: "personnel_fax",
					public_email: "login_email",
				};
				Object.keys(fields).forEach(function(fromField) {
					var toField = fields[fromField];
					Vue.set(entry, toField, entry[fromField]);
				});
			},
		},
		watch: {
			"entry.send_doc_to": function() {
				if (this.entry.send_doc_to === "その他") {
					this.entry.send_doc_to_address = "";
				}
			},
		},
	});

})(CE);
